import { computed, makeObservable } from 'mobx';
import Configuracao from '../../util/Configuracao';
import { Filtro } from './Filtro';

export default class FiltroMovimentosOuDecisaoAusentes extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    constructor(props) {
        super(props);

        makeObservable(this, {
            label: computed,
            labelMovimento: computed,
            labelDecisao: computed
        });
    }

    get label() {
        let rotulo = this.labelMovimento ? 'Códigos de ' : 'Código de ';
        rotulo +=
            this.labelMovimento && this.labelDecisao
                ? `${this.labelMovimento}/${this.labelDecisao}`
                : this.labelMovimento || this.labelDecisao;
        rotulo += this.labelMovimento ? ' ausentes' : ' ausente';
        return rotulo;
    }

    get labelMovimento() {
        return this.store.existeSessaoPJe ? 'movimentos CNJ' : undefined;
    }

    get labelDecisao() {
        return this.store.rootStore.parametroStore.isOrgaoTST && this.store.existeSessaoSIJ ? 'decisão' : undefined;
    }

    getValorOpcao(registro) {
        if (registro.processo.origem === Configuracao.ORIGEM_PJE) {
            return registro.movimentosCadastrados ? false : true;
        }
        return !this.isDecisaoCadastrada(registro);
    }

    isDecisaoCadastrada(registro) {
        return (
            registro &&
            registro.informacaoProcessoSalaSessao &&
            registro.informacaoProcessoSalaSessao.decisao &&
            Object.keys(registro.informacaoProcessoSalaSessao.decisao).length > 0
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
